// @flow

import { getProps } from '../props';
import create from '../Services/create';
import update from '../Services/update';

export default async (values: Function, dispatch: Function) => {

  const { onClose, didCreate, didUpdate } = getProps();

  // Clear uplift_notes and uplift_applied_to if uplift_percentage is 0 or null
  const submissionValues = { ...values };
  if (!submissionValues.uplift_percentage || submissionValues.uplift_percentage === 0) {
    submissionValues.uplift_notes = null;
    submissionValues.uplift_applied_to = null;
  }

  if (!values.id) {

    const project = await dispatch(create(submissionValues));

    onClose(true);

    if (didCreate) didCreate(project);

  } else {

    const project = await dispatch(update(submissionValues));

    onClose(true);

    if (didUpdate) didUpdate(project);

  }

}
